// // React & Core Hooks
// import React, { useState, useEffect } from "react";

// // Redux
// import { useSelector, useDispatch } from "react-redux";

// // React Router
// import { Link, useNavigate, useLocation, useParams } from "react-router-dom";

// // MUI Core
// import {
//   Box,
//   Container,
//   Grid,
//   Typography,
//   Paper,
//   Rating,
//   IconButton,
//   Button,
//   Chip,
//   ToggleButtonGroup,
//   ToggleButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Card,
//   CardContent,
//   CardMedia,
//   Fade,
//   Pagination,
//   Select,
//   MenuItem,
//   CircularProgress,
//   Tooltip,
//   TextField,
//   Snackbar,
//   Alert,
//   Tabs,
//   Tab,
//   Modal,
//   Autocomplete,
//   RadioGroup,
//   FormControlLabel,
//   FormLabel,
//   Radio,
//   FormControl,
//   InputLabel,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Divider,
//   useMediaQuery,
//   useTheme,
//   Breadcrumbs,
//   Link as MuiLink
// } from "@mui/material";

// // MUI Icons
// import {
//   Close as CloseIcon,
//   Straighten as StraightenIcon,
//   Favorite,
//   FavoriteBorder,
//   LocalGasStation,
//   DirectionsCar,
//   GridView,
//   List as ListIcon,
//   AddShoppingCart,
//   ChatBubbleOutline,
//   Add,
//   Remove,
//   Share,
//   ArrowBackIos,
//   ArrowForwardIos,
//   Close,
//   Calculate as CalculateIcon,
//   LocalShipping as LocalShippingIcon,
//   DirectionsCar as DirectionsCarIcon,
//   AttachMoney as AttachMoneyIcon,
//   InfoOutlined as InfoOutlinedIcon,
//   Receipt as ReceiptIcon,
//   Delete,
// } from "@mui/icons-material";

// // MUI Styling
// import { styled } from "@mui/material/styles";

// // Custom Components
// import Notes from "./header";
// import BasicSelectFilter from "./filter";
// import FooterManual from "./footerManual";
// import InquiryModal from "./inquiryModal";

// // Redux Actions
// import {
//   fetchCarsByBrand,
//   fetchCarsByBodyType,
//   fetchCarUsage,
//   fetchCarsByPrice,
//   fetchCarsByMileage,
//   fetchCarsByEngine,
//   fetchCarsByOtherSpecs,
//   fetchCarsByColor,
//   fetchAllCarModels,
//   addToWishlist,
//   fetchCart,
//   fetchWishlist,
// } from "./store";

// // Third-party Libraries
// import { useSnackbar } from "notistack";
// import axios from "axios";


// // ============================================================================
// // STYLED COMPONENTS
// // ============================================================================
// const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
//   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//   borderRadius: "12px",
//   overflow: "hidden",
//   marginBottom: "16px",
//   overflowX: "auto",
//   [theme.breakpoints.down("sm")]: {
//     borderRadius: "8px",
//     marginLeft: theme.spacing(-1),
//     marginRight: theme.spacing(-1),
//     width: `calc(100% + ${theme.spacing(2)})`,
//     "& .MuiTable-root": { minWidth: "650px" },
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   cursor: "pointer",
//   transition: "background-color 0.2s ease-in-out",
//   "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
//   [theme.breakpoints.down("sm")]: {
//     "& > .MuiTableCell-root": { padding: theme.spacing(1) },
//   },
// }));

// const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
//   backgroundColor: "#f5f5f5",
//   fontWeight: "bold",
//   position: "sticky",
//   top: 0,
//   zIndex: 10,
//   [theme.breakpoints.down("sm")]: {
//     padding: theme.spacing(1),
//     fontSize: "0.75rem",
//   },
// }));

// const StyledCard = styled(Card)(({ theme }) => ({
//   height: "100%",
//   display: "flex",
//   flexDirection: "column",
//   cursor: "pointer",
//   borderRadius: "10px",
//   overflow: "hidden",
//   boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//   transition: "all 0.3s ease",
//   "&:hover": {
//     boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//     transform: "translateY(-2px)",
//   },
//   [theme.breakpoints.down("sm")]: {
//     "& .MuiCardMedia-root": { height: "120px" },
//     "& .MuiCardContent-root": { padding: "20px 8px" },
//     "& .MuiButton-root": {
//       fontSize: "0.7rem",
//       padding: "4px 8px",
//       minWidth: "unset",
//     },
//     "& .MuiTypography-h6": { fontSize: "0.9rem" },
//     "& .MuiTypography-body2": { fontSize: "0.75rem" },
//     "& .MuiChip-root": {
//       height: "20px",
//       "& .MuiChip-label": { fontSize: "0.65rem" },
//     },
//   },
// }));

// const SpinningLogo = styled("img")(({ theme }) => ({
//   width: "150px",
//   height: "150px",
// }));

// // const ResponsiveBannerImage = styled("img")(({ theme }) => ({
// //   width: "100%",
// //   height: "50vh",
// //   objectFit: "cover",
// //   [theme.breakpoints.down("sm")]: {
// //     height: "35vh",
// //   },
// //   [theme.breakpoints.down("xs")]: {
// //     height: "30vh",
// //   },
// // }));

// // ============================================================================
// // WISHLIST GRID CARD COMPONENT
// // ============================================================================

// const WishlistGridCard = ({ item, onRemove, onMoveToCart, onInquiry, imageUrl, car, onCarClick }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { enqueueSnackbar } = useSnackbar();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const [isHovered, setIsHovered] = useState(false);
//   const [openInquiryModal, setOpenInquiryModal] = useState(false);
//   const [inquiryProduct, setInquiryProduct] = useState(null);
//   const [modalImage, setModalImage] = useState(null);

//   const fetchProductData = async (carModelId) => {
//     try {
//       const response = await axios.get(
//         `https://car.amar.co.jp/api/dashboard/product/get/Model/details/${carModelId}`
//       );
//       return response.data?.data || null;
//     } catch (err) {
//       console.error('Error fetching product data:', err);
//       return null;
//     }
//   };

//   const handleInquiryClick = async (e, carModelId) => {
//     e.stopPropagation();
//     const productData = await fetchProductData(carModelId);
//     if (productData) {
//       setInquiryProduct(productData);
//       setModalImage(`https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${carModelId}`);
//       setOpenInquiryModal(true);
//     } else {
//       enqueueSnackbar('Failed to load car details for inquiry.', { variant: 'error' });
//     }
//   };

//   const handleInquiryClose = () => {
//     setOpenInquiryModal(false);
//     setInquiryProduct(null);
//     setModalImage(null);
//   };

//   return (
//     <StyledCard
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       sx={{
//         "&:hover": {
//           boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
//           transform: "translateY(-4px)",
//         },
//         transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
//       }}
//     >
//       <Box
//         sx={{
//           position: "relative",
//           overflow: "hidden",
//         }}
//         onClick={() => onCarClick(item.modelId)}
//       >
//         <CardMedia
//           component="img"
//           height="100%"
//           image={`https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${item.modelId}`}
//           alt={`${item.brand} ${item.modelName}`}
//           sx={{
//             transition: "transform 0.5s ease",
//             transform: isHovered ? "scale(1.05)" : "scale(1)",
//             objectFit: "cover",
//             minHeight: "200px",
//             backgroundColor: "#f5f5f5",
//           }}
//           onError={(e) => {
//             e.target.onerror = null;
//             e.target.src = "carousel/carslider.png";
//           }}
//         />

//         <IconButton
//           sx={{
//             position: "absolute",
//             top: 8,
//             right: 8,
//             backgroundColor: "rgba(255,255,255,0.9)",
//             padding: isMobile ? "4px" : "8px",
//             "&:hover": {
//               backgroundColor: "rgba(255,255,255,1)",
//               transform: "scale(1.1)",
//             },
//             transition: "all 0.2s ease",
//           }}
//           onClick={(e) => {
//             e.stopPropagation();
//             onRemove(item.modelId);
//           }}
//         >
//           <Delete
//             sx={{
//               fontSize: isMobile ? "1rem" : "1.25rem",
//               color: theme.palette.error.main,
//             }}
//           />
//         </IconButton>
//       </Box>

//       <Box
//         sx={{
//           marginTop: "-15px",
//           marginLeft: "15px",
//           bottom: 8,
//           left: 8,
//           display: "flex",
//           gap: 0.5,
//           flexWrap: "wrap",
//           zIndex: "1111"
//         }}
//       >
//      {item.sold && (
//   <Box
//     sx={{
//       position: "absolute",
//       top: "50%",
//       left: "50%",
//       transform: "translate(-50%, -50%)",
//       backgroundColor: "rgba(0, 0, 0, 0.8)",
//       color: "white",
//       padding: "12px 32px",
//       borderRadius: "8px",
//       fontSize: isMobile ? "1.5rem" : "2rem",
//       fontWeight: "bold",
//       zIndex: 2,
//       border: "3px solid #ff0000",
//       boxShadow: "0 4px 12px rgba(255, 0, 0, 0.5)",
//       letterSpacing: "2px",
//     }}
//   >
//     SOLD
//   </Box>
// )}

//         {item.ourPick && (
//           <Chip
//             label="Our Pick"
//             size="small"
//             sx={{
//               fontSize: isMobile ? "0.55rem" : "0.65rem",
//               height: isMobile ? "16px" : "26px",
//               color: "#dd006e",
//               backgroundColor: "#ffbddf",
//               fontWeight: "bold",
//               border: "1px solid #FF69B4",
//               "&:hover": { backgroundColor: "white" },
//             }}
//           />
//         )}
//         {item.carGrade && (
//           <Chip
//             label={`Grade ${item.carGrade || "A"}`}
//             size="small"
//             sx={{
//               fontSize: isMobile ? "0.55rem" : "0.65rem",
//               height: isMobile ? "16px" : "26px",
//               color: "#009966",
//               backgroundColor: "#9fffe7",
//               fontWeight: "bold",
//               border: "1px solid #00FFAA",
//               "&:hover": { backgroundColor: "white" },
//             }}
//           />
//         )}
//         {item.specialDeal && (
//           <Chip
//             label="Special Offer"
//             size="small"
//             sx={{
//               fontSize: isMobile ? "0.55rem" : "0.65rem",
//               height: isMobile ? "16px" : "26px",
//               backgroundColor: "#d09fff",
//               color: "#6c2aab",
//               fontWeight: "bold",
//               border: "1px solid #6c2aab",
//               "&:hover": { backgroundColor: "white" },
//             }}
//           />
//         )}
//       </Box>

//       <CardContent
//         sx={{
//           flexGrow: 1,
//           p: isMobile ? 1.5 : 2,
//           display: "flex",
//           flexDirection: "column",
//         }}
//         onClick={() => onCarClick(item.modelId)}
//       >
//         <Box>
//           <Typography
//             variant="h6"
//             sx={{
//               fontSize: isMobile ? "1rem" : "1.125rem",
//               fontWeight: 700,
//               mb: 0.5,
//               color: theme.palette.text.primary,
//               display: '-webkit-box',
//               WebkitLineClamp: 2,
//               WebkitBoxOrient: 'vertical',
//               overflow: 'hidden',
//               textOverflow: 'ellipsis',
//             }}
//           >
//             {item.brand} {item.modelName} {item.registrationDate?.split("-")[0]}
//           </Typography>
//         </Box>

//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: "repeat(2, 1fr)",
//             gap: 1,
//             "& > div": {
//               display: "flex",
//               alignItems: "center",
//               gap: 0.5,
//             },
//           }}
//         >
//           <Box>
//             <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "1rem" }}>Ref #:</Typography>
//             <Typography variant="body2" sx={{ fontWeight: 500, fontSize: isMobile ? "0.75rem" : "0.8125rem" }}>{item.refNumber || "N/A"}</Typography>
//           </Box>
//           <Box>
//             <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "1rem" }}>Year:</Typography>
//             <Typography variant="body2" sx={{ fontWeight: 500, fontSize: isMobile ? "0.75rem" : "0.8125rem" }}>{item.registrationDate?.split("-")[0] || "N/A"}</Typography>
//           </Box>
//           <Box>
//             <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "1rem" }}>Engine:</Typography>
//             <Typography variant="body2" sx={{ fontWeight: 500, fontSize: isMobile ? "0.75rem" : "0.8125rem" }}>{item.carEngineCC || "N/A"}</Typography>
//           </Box>
//           <Box sx={{ display: "flex" }}>
//             <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "1rem" }}>Fuel:</Typography>
//             <Typography variant="body2" sx={{ fontSize: isMobile ? "0.65rem" : "0.75rem", color: theme.palette.text.primary }}>{item.fuel || "N/A"}</Typography>
//           </Box>
//         </Box>

//         <Box sx={{ display: "flex", gap: "8px" }}>
//           <Typography variant="caption" sx={{ fontWeight: 500, color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "20px" }}>Price:</Typography>
//           <Typography variant="h6" sx={{ fontSize: isMobile ? "1rem" : "20px", fontWeight: 700, color: theme.palette.error.main }}>{item.price ? `$${item.price.toLocaleString()}` : "Price on request"}</Typography>
//         </Box>
//       </CardContent>

//       <Box sx={{ p: isMobile ? 1 : 1.5, pt: 0, display: "flex", justifyContent: "space-between", gap: 1 }}>
//         <Button
//           variant="contained"
//           size="medium"
//           sx={{
//             bgcolor: "transparent",
//             color: "red",
//             border: "1px solid red",
//             borderRadius: "50px",
//             fontSize: "0.75rem",
//             fontWeight: "600",
//             padding: "18px 18px",
//             width: "48%",
//             height: "38px",
//             transition: "all 0.3s ease",
//             overflow: "hidden",
//             position: "relative",
//             zIndex: 1,
//             "&::before": {
//               content: '""',
//               position: "absolute",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100%",
//               background: "red",
//               transform: "translateX(-100%)",
//               transition: "transform 0.3s ease",
//               zIndex: -1,
//             },
//             "&:hover": {
//               color: "white",
//               boxShadow: "0 3px 6px rgba(255,0,0,0.3)",
//               "&::before": { transform: "translateX(0)" },
//             },
//           }}
//           onClick={(e) => handleInquiryClick(e, item.modelId)}
//         >
//           INQUIRY
//         </Button>

//         {/* <Button
//           variant="contained"
//           size="medium"
//           sx={{
//             bgcolor: "red",
//             color: "white",
//             border: "1px solid red",
//             borderRadius: "50px",
//             fontSize: "0.75rem",
//             fontWeight: "600",
//             padding: "18px 18px",
//             width: "48%",
//             height: "38px",
//             transition: "all 0.3s ease",
//             overflow: "hidden",
//             position: "relative",
//             zIndex: 1,
//             "&::before": {
//               content: '""',
//               position: "absolute",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100%",
//               background: "red",
//               transform: "translateX(-100%)",
//               transition: "transform 0.3s ease",
//               zIndex: -1,
//             },
//             "&:hover": {
//               color: "white",
//               boxShadow: "0 3px 6px rgba(255,0,0,0.3)",
//               "&::before": { transform: "translateX(0)" },
//             },
//           }}
//           onClick={(e) => {
//             e.stopPropagation();
//             onMoveToCart(item.modelId);
//           }}
//         >
//           MOVE TO CART
//         </Button> */}
//       </Box>

//       <InquiryModal open={openInquiryModal} onClose={handleInquiryClose} product={inquiryProduct} imageUrl1={modalImage} />
//     </StyledCard>
//   );
// };

// // ============================================================================
// // WISHLIST TABLE COMPONENT
// // ============================================================================

// const WishlistTable = ({ items, onRemove, onMoveToCart, onInquiry, car, imageUrl, onCarClick }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
//   const visibleColumns = isMobile ? 10 : isTablet ? 10 : 11;
//   const navigate = useNavigate();
//   const { enqueueSnackbar } = useSnackbar();
//   const [openInquiryModal, setOpenInquiryModal] = useState(false);
//   const [inquiryProduct, setInquiryProduct] = useState(null);
//   const [modalImage, setModalImage] = useState(null);

//   const fetchProductData = async (carModelId) => {
//     try {
//       const response = await axios.get(
//         `https://car.amar.co.jp/api/dashboard/product/get/Model/details/${carModelId}`
//       );
//       return response.data?.data || null;
//     } catch (err) {
//       console.error('Error fetching product data:', err);
//       return null;
//     }
//   };

//   const handleInquiryClick = async (e, carModelId) => {
//     e.stopPropagation();
//     const productData = await fetchProductData(carModelId);
//     if (productData) {
//       setInquiryProduct(productData);
//       setModalImage(`https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${carModelId}`);
//       setOpenInquiryModal(true);
//     } else {
//       enqueueSnackbar('Failed to load car details for inquiry.', { variant: 'error' });
//     }
//   };

//   const handleInquiryClose = () => {
//     setOpenInquiryModal(false);
//     setInquiryProduct(null);
//     setModalImage(null);
//   };

//   return (
//     <>
//       <StyledTableContainer component={Paper}>
//         <Table stickyHeader sx={{ minWidth: isMobile ? "650px" : "800px" }}>
//           <TableHead>
//             <TableRow>
//               <StyledTableHeaderCell align="center">Drive This Beauty</StyledTableHeaderCell>
//               {visibleColumns > 1 && <StyledTableHeaderCell align="center">Referance Number</StyledTableHeaderCell>}
//               {visibleColumns > 2 && <StyledTableHeaderCell align="center">Chassis Number</StyledTableHeaderCell>}
//               {visibleColumns > 3 && <StyledTableHeaderCell align="center">Registration Year</StyledTableHeaderCell>}
//               {visibleColumns > 4 && <StyledTableHeaderCell align="center">Engine CC / Motor kW</StyledTableHeaderCell>}
//               {visibleColumns > 5 && <StyledTableHeaderCell align="center">Fuel Type</StyledTableHeaderCell>}
//               {visibleColumns > 7 && <StyledTableHeaderCell align="center">Body Color</StyledTableHeaderCell>}
//               {visibleColumns > 8 && <StyledTableHeaderCell align="center">Car Doors</StyledTableHeaderCell>}
//               {visibleColumns > 9 && <StyledTableHeaderCell align="center">Price</StyledTableHeaderCell>}
//               <StyledTableHeaderCell align="center">Actions</StyledTableHeaderCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {items.map((item) => (
//               <StyledTableRow key={item.modelId} onClick={() => onCarClick(item.modelId)}>
//                 <TableCell sx={{ px: { xs: 1, sm: 2 }, }}>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: isMobile ? 1 : 2 }}>
//                     <Box sx={{ position: "relative", width: isMobile ? 60 : 80, height: isMobile ? 45 : 60, flexShrink: 0 }}>
//                       <Box
//                         component="img"
//                         src={`https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${item.modelId}`}
//                         alt={`${item.brand} ${item.modelName}`}
//                         sx={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 1, boxShadow: "0 4px 8px rgba(0,0,0,0.1)", backgroundColor: "#f5f5f5" }}
//                         onError={(e) => {
//                           e.target.onerror = null;
//                           e.target.src = "carousel/carslider.png";
//                         }}
//                       />
//                       <IconButton
//                         size="small"
//                         color="error"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           onRemove(item.modelId);
//                         }}
//                         sx={{ position: "absolute", top: 2, right: 2, padding: isMobile ? "2px" : "3px", backgroundColor: "rgba(255,255,255,0.8)" }}
//                       >
//                         <Delete sx={{ fontSize: isMobile ? 10 : 14 }} />
//                       </IconButton>
//                     </Box>
//                     <Box sx={{ flex: 1, minWidth: 0 }}>
//                       <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.875rem", wordWrap: "break-word", whiteSpace: "normal", lineHeight: 1.3 }}>
//                         {item.brand} {item.modelName} {item.registrationDate?.split("-")[0]}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </TableCell>

//                 {/* {visibleColumns > 1 && (
//                   <TableCell sx={{ padding: isMobile ? "4px" : "8px" }}>
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                       {item.ourPick && <Chip label="Our Pick" size="small" sx={{ fontSize: isMobile ? "0.55rem" : "0.65rem", height: isMobile ? "16px" : "24px", color: "#dd006e", backgroundColor: "#ffbddf", fontWeight: "bold", border: "1px solid #FF69B4" }} />}
//                       <Chip label={`Grade ${item.carGrade || "A"}`} size="small" sx={{ fontSize: isMobile ? "0.55rem" : "0.65rem", height: isMobile ? "16px" : "24px", color: "#009966", backgroundColor: "#9fffe7", fontWeight: "bold", border: "1px solid #00FFAA" }} />
//                       {item.specialDeal && <Chip label="Special Offer" size="small" sx={{ fontSize: isMobile ? "0.55rem" : "0.65rem", height: isMobile ? "16px" : "24px", backgroundColor: "#d09fff", color: "#6c2aab", fontWeight: "bold", border: "1px solid #70f8ff" }} />}
//                     </Box>
//                   </TableCell>
//                 )} */}
//                 {/* {visibleColumns > 1 && (
//                   <TableCell sx={{ padding: isMobile ? "4px" : "8px" }}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "column",
//                         gap: 0.5,
//                       }}
//                     >
                      
//                       {!item.ourPick && !item.carGrade && !item.specialDeal ? (
//                         <Chip
//                           label="Null"
//                           size="small"
//                           sx={{
//                             fontSize: isMobile ? "0.55rem" : "0.65rem",
//                             height: isMobile ? "16px" : "24px",
//                             color: "#666",
//                             backgroundColor: "#eee",
//                             fontWeight: "bold",
//                             border: "1px solid #ccc",
//                           }}
//                         />
//                       ) : (
//                         <>
//                           {item.ourPick && (
//                             <Chip
//                               label="Our Pick"
//                               size="small"
//                               sx={{
//                                 fontSize: isMobile ? "0.55rem" : "0.65rem",
//                                 height: isMobile ? "16px" : "24px",
//                                 color: "#dd006e",
//                                 backgroundColor: "#ffbddf",
//                                 fontWeight: "bold",
//                                 border: "1px solid #FF69B4",
//                               }}
//                             />
//                           )}

//                           {item.carGrade && (
//                             <Chip
//                               label={`Grade ${item.carGrade}`}
//                               size="small"
//                               sx={{
//                                 fontSize: isMobile ? "0.55rem" : "0.65rem",
//                                 height: isMobile ? "16px" : "24px",
//                                 color: "#009966",
//                                 backgroundColor: "#9fffe7",
//                                 fontWeight: "bold",
//                                 border: "1px solid #00FFAA",
//                               }}
//                             />
//                           )}

//                           {item.specialDeal && (
//                             <Chip
//                               label="Special Offer"
//                               size="small"
//                               sx={{
//                                 fontSize: isMobile ? "0.55rem" : "0.65rem",
//                                 height: isMobile ? "16px" : "24px",
//                                 backgroundColor: "#d09fff",
//                                 color: "#6c2aab",
//                                 fontWeight: "bold",
//                                 border: "1px solid #70f8ff",
//                               }}
//                             />
//                           )}
//                         </>
//                       )}
//                     </Box>
//                   </TableCell>
//                 )} */}
//                 {visibleColumns > 1 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem", fontFamily: "monospace" }}>{item.refNumber || "N/A"}</Typography></TableCell>}
//                 {visibleColumns > 2 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem", fontFamily: "monospace" }}>{item.carChassisNumber || "N/A"}</Typography></TableCell>}
//                 {visibleColumns > 3 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem" }}>{item.registrationDate ? item.registrationDate.split('-')[0] : "N/A"}</Typography></TableCell>}
//                 {visibleColumns > 4 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem" }}>{item.carEngineCC ? `${item.carEngineCC}` : "N/A"}</Typography></TableCell>}
//                 {visibleColumns > 5 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem" }}>{item.fuel || "N/A"}</Typography></TableCell>}
//                 {visibleColumns > 7 && (
//                   <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}>
//                     <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
//                       <Box sx={{ width: isMobile ? 12 : 16, height: isMobile ? 12 : 16, borderRadius: "50%", backgroundColor: item.carColor?.toLowerCase() || "#ccc", border: "1px solid #ddd", mr: 0.5 }} />
//                       <Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem" }}>{item.carColor || "N/A"}</Typography>
//                     </Box>
//                   </TableCell>
//                 )}
//                 {visibleColumns > 8 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem", fontFamily: "monospace" }}>{item.doors || "N/A"}</Typography></TableCell>}
//                 {visibleColumns > 9 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.95rem", color: "error.main" }}>{item.price ? `$${item.price.toLocaleString()}` : "On Request"}</Typography></TableCell>}

//                 <TableCell align="center">
//                   <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: 0.8, position: "relative", padding: "6px 0" }}>
//                     <Button variant="contained" size="small" sx={{ bgcolor: "transparent", color: "red", border: "1px solid red", borderRadius: "16px", fontSize: "0.75rem", padding: "3px 12px", minWidth: "80px", height: "28px", transition: "all 0.3s ease", position: "relative", zIndex: 1, "&:hover": { color: "white", boxShadow: "0 3px 6px rgba(255,0,0,0.3)" } }} onClick={(e) => handleInquiryClick(e, item.modelId)}>
//                       INQUIRY
//                     </Button>
//                     {/* <Button
//                       variant="contained"
//                       size="small"
//                       sx={{
//                         bgcolor: "red",
//                         color: "white",
//                         borderRadius: "16px",
//                         fontSize: "0.72rem",
//                         padding: "3px 10px",
//                         minWidth: "92px",
//                         height: "28px",
//                         whiteSpace: "nowrap",
//                         lineHeight: 1,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           bgcolor: "#c00",
//                           boxShadow: "0 4px 10px rgba(255,0,0,0.3)",
//                         },
//                       }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         onMoveToCart(item.modelId);
//                       }}
//                     >
//                       MOVE TO CART
//                     </Button> */}
//                   </Box>
//                 </TableCell>
//               </StyledTableRow>
//             ))}

//             {item.sold && (
//   <Box
//     sx={{
//       position: "absolute",
//       top: "50%",
//       left: "50%",
//       transform: "translate(-50%, -50%)",
//       backgroundColor: "rgba(0, 0, 0, 0.85)",
//       color: "white",
//       padding: isMobile ? "4px 12px" : "6px 16px",
//       borderRadius: "4px",
//       fontSize: isMobile ? "0.65rem" : "0.875rem",
//       fontWeight: "bold",
//       zIndex: 2,
//       border: "2px solid #ff0000",
//       letterSpacing: "1px",
//     }}
//   >
//     SOLD
//   </Box>
// )}

//   {item.sold && (
//     <Box
//       sx={{
//         position: "absolute",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         backgroundColor: "rgba(0, 0, 0, 0.8)",
//         color: "white",
//         padding: "12px 32px",
//         borderRadius: "8px",
//         fontSize: isMobile ? "1.5rem" : "2rem",
//         fontWeight: "bold",
//         zIndex: 2,
//         border: "3px solid #ff0000",
//         boxShadow: "0 4px 12px rgba(255, 0, 0, 0.5)",
//         letterSpacing: "2px",
//       }}
//     >
//       SOLD
//     </Box>
//   )}

//           </TableBody>
//         </Table>
//       </StyledTableContainer>
//       <InquiryModal open={openInquiryModal} onClose={handleInquiryClose} product={inquiryProduct} imageUrl1={modalImage} />
//     </>
//   );
// };

// // ============================================================================
// // MAIN WISHLIST COMPONENT
// // ============================================================================

// const Wishlist = () => {
//   const [loading, setLoading] = useState(true);
//   const [viewMode, setViewMode] = useState("grid");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(20);
//   const [totalPages, setTotalPages] = useState(1);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [selectedModelId, setSelectedModelId] = useState(null);
//   const [openMoveToCartDialog, setOpenMoveToCartDialog] = useState(false);
//   const [selectedMoveModelId, setSelectedMoveModelId] = useState(null);
//   const dispatch = useDispatch();
//   const { enqueueSnackbar } = useSnackbar();

//   const wishlistState = useSelector(state => state.wishlist);
//   const wishlistItems = wishlistState?.items || [];

//   const handleClick = () => {
//     navigate("/myAccount");
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//           navigate("/login");
//           return;
//         }

//         await dispatch(fetchWishlist());
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching wishlist data:", error);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [dispatch, navigate]);

//   useEffect(() => {
//     setTotalPages(Math.ceil(wishlistItems.length / itemsPerPage));
//     setCurrentPage(1);
//   }, [wishlistItems.length, itemsPerPage]);

//   useEffect(() => {
//     if (isMobile) {
//       setViewMode("grid");
//     } else {
//       setViewMode("list");
//     }
//   }, [isMobile]);

//   const handleRemoveItem = async (modelId) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       if (!token) return;

//       const response = await fetch(
//         `https://car.amar.co.jp/api/master/car-cart-and-whishlist/delete/item?Enter%20ModelId=${modelId}`,
//         {
//           method: "DELETE",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const data = await response.json();

//       if (data.code === 200) {
//         dispatch(fetchWishlist());
//         enqueueSnackbar("Item removed from wishlist", { variant: 'success' });
//       }
//     } catch (error) {
//       console.error("Error removing item:", error);
//       enqueueSnackbar("Error removing item", { variant: 'error' });
//     }
//   };

//   const handleCarClick = (modelId) => {
//     if (modelId) {
//       navigate(`/product/${modelId}`);
//     } else {
//       console.error('No modelId provided for navigation');
//     }
//   };

//   const handleMoveToCart = async (modelId) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       if (!token) return;

//       const response = await fetch(
//         `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=MOVE_TO_CART`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const data = await response.json();

//       if (data.code === 200) {
//         dispatch(fetchWishlist());
//         dispatch(fetchCart());
//         enqueueSnackbar("Item moved to cart", { variant: 'success' });
//       } else {
//         console.error("Failed to move item to cart:", data.message);
//         enqueueSnackbar("Failed to move item to cart", { variant: 'error' });
//       }
//     } catch (error) {
//       console.error("Error moving item to cart:", error);
//       enqueueSnackbar("Error moving item to cart", { variant: 'error' });
//     }
//   };

//   const handleViewMode = (event, newViewMode) => {
//     if (newViewMode !== null) {
//       setViewMode(newViewMode);
//     }
//   };

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//     window.scrollTo(0, 0);
//   };

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(e.target.value);
//     setCurrentPage(1);
//     setTotalPages(Math.ceil(wishlistItems.length / e.target.value));
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = wishlistItems.slice(indexOfFirstItem, indexOfLastItem);

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <SpinningLogo src="/image/footer-logo-small.svg" alt="Loading" />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Box sx={{ mb: 0 }}>
//         <Box sx={{ marginBottom: "0%" }}>
//           <Notes />
//         </Box>
//       </Box>

//       {/* <Box sx={{ position: "relative" }}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: isMobile ? "5%" : "5%",
//             left: isMobile ? "3%" : "5%",
//             margin: 0,
//             color: "white",
//             fontSize: isMobile ? "12px" : "15px",
//             backgroundColor: "rgba(0, 0, 0, 0.5)",
//             padding: isMobile ? "4px 8px" : "5px 10px",
//             borderRadius: "5px",
//             zIndex: 1,
//           }}
//         >
//           <Typography
//             component="span"
//             sx={{
//               opacity: 0.5,
//               marginRight: isMobile ? "2px" : "5px",
//             }}
//           >
//             <Link
//               to="http://3.110.209.177"
//               style={{
//                 fontSize: isMobile ? "10px" : "13px",
//                 color: "white",
//                 textDecoration: "none",
//               }}
//             >
//               Home /
//             </Link>
//           </Typography>
//           <Link
//             to="https://car.amar.co.jp/MyAccount"
//             style={{
//               fontSize: isMobile ? "10px" : "13px",
//               color: "white",
//               textDecoration: "none",
//             }}
//           >
//             My Account
//           </Link>
//           / Wishlist
//         </Box>

//         <ResponsiveBannerImage src="images/wishlist.png" alt="bg" />

//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             color: "#EBEBEB",
//             fontSize: { xs: "16px", sm: "24px", md: "28px", lg: "30px" },
//             fontFamily: "Roboto",
//             textAlign: "center",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             alignItems: "center",
//             width: "90%",
//             textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)",
//             gap: isMobile ? "10px" : "20px",
//           }}
//         >
//           <Typography
//             variant="h4"
//             component="div"
//             sx={{
//               fontWeight: "bold",
//               fontSize: isMobile ? "1.5rem" : "2.125rem",
//             }}
//           >
//             Wishlist
//           </Typography>
//           <button
//             onClick={handleClick}
//             style={{
//               backgroundColor: "#EB2329",
//               color: "white",
//               border: "none",
//               padding: isMobile ? "8px 16px" : "10px 20px",
//               fontSize: isMobile ? "14px" : "16px",
//               borderRadius: "8px",
//               cursor: "pointer",
//               textTransform: "uppercase",
//               transition: "background-color 0.3s ease",
//               marginTop: isMobile ? "5px" : "10px",
//             }}
//             onMouseOver={(e) => (e.target.style.backgroundColor = "#c41f23")}
//             onMouseOut={(e) => (e.target.style.backgroundColor = "#EB2329")}
//           >
//             My Account
//           </button>
//         </Box>
//       </Box> */}
//       <Box
//         className="image-container-Wishlist"
//         sx={{
//           position: "relative",
//           width: "100%",
//           height: { xs: "30vh", sm: "40vh", md: "50vh" },
//           backgroundColor: "black",
//         }}
//       >
//         {/* Background Image */}
//         <Box
//           component="img"
//           src="/images/wishlist.png"
//           alt="Wishlist Background"
//           sx={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             opacity: 0.3,
//           }}
//         />

//         {/* Breadcrumb */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: { xs: "5%", sm: "5%", md: "5%" },
//             left: { xs: "3%", sm: "5%", md: "5%" },
//             color: "white",
//             fontSize: { xs: "11px", sm: "13px", md: "15px" },
//             backgroundColor: "rgba(0, 0, 0, 0.5)",
//             padding: { xs: "4px 8px", sm: "5px 10px", md: "5px 10px" },
//             borderRadius: "5px",
//           }}
//         >
//           <Typography
//             component="span"
//             sx={{
//               opacity: 0.5,
//               marginRight: { xs: "2px", sm: "5px" },
//             }}
//           >
//             <Link
//               to="http://3.110.209.177"
//               style={{
//                 fontSize: "inherit",
//                 color: "white",
//                 textDecoration: "none",
//               }}
//             >
//               Home/
//             </Link>
//           </Typography>

//           <Link
//             to="https://car.amar.co.jp/MyAccount"
//             style={{
//               fontSize: "inherit",
//               color: "white",
//               textDecoration: "none",
//             }}
//           >
//             My Account
//           </Link>

//           / Wishlist
//         </Box>

//         {/* Center Content */}
//         <Box
//           sx={{
//             position: "absolute",
//             left: "50%",
//             top: "50%",
//             transform: "translate(-50%, -50%)",
//             color: "white",
//             fontSize: { xs: "1.5rem", sm: "2rem", md: "30px" },
//             fontFamily: "Roboto",
//             fontWeight: 700,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             gap: { xs: "10px", sm: "15px", md: "20px" },
//             textAlign: "center",
//             width: "90%",
//           }}
//         >
//           Wishlist

//           <Box
//             component="button"
//             onClick={handleClick}
//             sx={{
//               backgroundColor: "#EB2329",
//               color: "white",
//               border: "none",
//               px: { xs: 2, sm: 2.5, md: 3 },
//               py: { xs: 1, sm: 1.2, md: 1.4 },
//               fontSize: { xs: "14px", sm: "15px", md: "16px" },
//               borderRadius: "8px",
//               cursor: "pointer",
//               textTransform: "uppercase",
//               transition: "background-color 0.3s ease",
//               "&:hover": {
//                 backgroundColor: "#c41f23",
//               },
//             }}
//           >
//             My Account
//           </Box>
//         </Box>
//       </Box>


//       <Container
//         maxWidth="xl"
//         sx={{
//           width: "90%",
//           backgroundColor: "#FFFFFF",
//           border: "2px solid #EBEBEB",
//           borderRadius: "10px",
//           marginTop: "-75px",
//           marginBottom: "100px",
//           position: "relative",
//           zIndex: 1,
//           minHeight: "400px",
//           p: { xs: 2, md: 4 },
//         }}
//       >
//         <Paper
//           elevation={0}
//           sx={{
//             p: isMobile ? 2 : 3,
//             mb: 4,
//             borderRadius: "10px",
//             backgroundColor: "#f9f9f9",
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               justifyContent: "space-between",
//               alignItems: isMobile ? "flex-start" : "center",
//               gap: isMobile ? 2 : 0,
//             }}
//           >
//             <Box>
//               <Typography
//                 variant="h5"
//                 sx={{
//                   fontWeight: "bold",
//                   fontSize: isMobile ? "1.1rem" : "1.5rem",
//                   color: "error.main",
//                 }}
//               >
//                 My Wishlist
//               </Typography>
//               <Typography
//                 variant="body1"
//                 color="text.secondary"
//                 sx={{ fontSize: isMobile ? "0.85rem" : "1rem" }}
//               >
//                 {wishlistItems.length}{" "}
//                 {wishlistItems.length === 1 ? "result" : "results"} found
//               </Typography>
//             </Box>
//             <ToggleButtonGroup
//               value={viewMode}
//               exclusive
//               onChange={handleViewMode}
//               size={isMobile ? "small" : "medium"}
//               sx={{
//                 "& .MuiToggleButton-root": {
//                   border: "1px solid rgba(0, 0, 0, 0.12)",
//                   color: "black",
//                   "&.Mui-selected": {
//                     backgroundColor: "red",
//                     color: "white",
//                     "&:hover": {
//                       backgroundColor: "#cc0000",
//                     },
//                   },
//                 },
//               }}
//             >
//               <ToggleButton value="list" title="List View">
//                 <ListIcon fontSize={isMobile ? "small" : "medium"} />
//               </ToggleButton>
//               <ToggleButton value="grid" title="Grid View">
//                 <GridView fontSize={isMobile ? "small" : "medium"} />
//               </ToggleButton>
//             </ToggleButtonGroup>
//           </Box>
//         </Paper>

//         {wishlistItems.length === 0 ? (
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               minHeight: "300px",
//               textAlign: "center",
//             }}
//           >
//             <Favorite sx={{ fontSize: isMobile ? 40 : 60, color: "gray", mb: 2 }} />
//             <Typography
//               variant="h6"
//               sx={{ mb: 1, fontSize: isMobile ? "1rem" : "1.25rem" }}
//             >
//               Your wishlist is empty
//             </Typography>
//             <Typography
//               variant="body2"
//               color="text.secondary"
//               sx={{ mb: 3, fontSize: isMobile ? "0.85rem" : "1rem" }}
//             >
//               You haven't added any items to your wishlist yet.
//             </Typography>
//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "#d32f2f",
//                 "&:hover": { backgroundColor: "#b71c1c" },
//                 fontSize: isMobile ? "0.85rem" : "1rem",
//               }}
//               onClick={() => navigate("/")}
//             >
//               Browse Cars
//             </Button>
//           </Box>
//         ) : (
//           <>
//             {viewMode === "list" ? (
//               <WishlistTable
//                 items={currentItems}
//                 onCarClick={handleCarClick}
//                 car={currentItems}
//                 onRemove={(id) => {
//                   setSelectedModelId(id);
//                   setOpenDeleteDialog(true);
//                 }}
//                 onMoveToCart={(id) => {
//                   setSelectedMoveModelId(id);
//                   setOpenMoveToCartDialog(true);
//                 }}
//               />
//             ) : (
//               <Grid container spacing={isMobile ? 1 : 3}>
//                 {currentItems.map((item) => (
//                   <Grid
//                     item
//                     xs={12}
//                     sm={6}
//                     md={4}
//                     lg={3}
//                     key={item.modelId}
//                   >
//                     <WishlistGridCard
//                       item={item}
//                       onCarClick={handleCarClick}
//                       car={item}
//                       onRemove={() => {
//                         setSelectedModelId(item.modelId);
//                         setOpenDeleteDialog(true);
//                       }}
//                       onMoveToCart={() => {
//                         setSelectedMoveModelId(item.modelId);
//                         setOpenMoveToCartDialog(true);
//                       }}
//                       onInquiry={() => console.log("Inquiry clicked")}
//                     />
//                   </Grid>
//                 ))}
//               </Grid>
//             )}

//             {wishlistItems.length > 0 && (
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mt: 4,
//                   flexDirection: isMobile ? "column" : "row",
//                   gap: 2,
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: "black",
//                       fontWeight: 500,
//                       letterSpacing: "0.5px",
//                       fontSize: isMobile ? "0.85rem" : "1rem",
//                     }}
//                   >
//                     Results per page:
//                   </Typography>
//                 </Box>

//                 <Pagination
//                   count={totalPages || 0}
//                   page={currentPage}
//                   onChange={handlePageChange}
//                   variant="outlined"
//                   shape="rounded"
//                   size={isMobile ? "small" : "medium"}
//                   sx={{
//                     display: "flex",
//                     justifyContent: "center",
//                     "& .MuiPaginationItem-root": {
//                       fontWeight: 500,
//                       borderColor: "black",
//                       color: "black",
//                       "&:hover": {
//                         backgroundColor: "rgba(255, 0, 0, 0.1)",
//                         borderColor: "red",
//                       },
//                     },
//                     "& .Mui-selected": {
//                       backgroundColor: "red !important",
//                       color: "white",
//                       borderColor: "red",
//                       "&:hover": {
//                         backgroundColor: "#b30000 !important",
//                         borderColor: "#800000",
//                       },
//                     },
//                   }}
//                 />

//                 <Select
//                   value={itemsPerPage}
//                   onChange={handleItemsPerPageChange}
//                   variant="outlined"
//                   displayEmpty
//                   size="small"
//                   sx={{
//                     width: isMobile ? 70 : 80,
//                     color: "black",
//                     fontWeight: 500,
//                     backgroundColor: "#fff",
//                     borderColor: "black",
//                     "& .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "black",
//                     },
//                     "&:hover .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "red",
//                     },
//                     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "red",
//                     },
//                     "& .MuiSvgIcon-root": {
//                       color: "red",
//                     },
//                   }}
//                 >
//                   <MenuItem value={20}>20</MenuItem>
//                   <MenuItem value={50}>50</MenuItem>
//                   <MenuItem value={100}>100</MenuItem>
//                 </Select>
//               </Box>
//             )}
//           </>
//         )}
//       </Container>

//       <FooterManual />

//       <Modal open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: isMobile ? "85%" : 400,
//             maxWidth: 400,
//             bgcolor: "background.paper",
//             borderRadius: "12px",
//             boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//             overflow: "hidden",
//           }}
//         >
//           <Box sx={{ px: 3, py: 2 }}>
//             <Typography
//               variant="h6"
//               component="h2"
//               sx={{
//                 fontWeight: 600,
//                 fontSize: isMobile ? "1rem" : "1.25rem",
//               }}
//             >
//               Remove from Wishlist
//             </Typography>
//           </Box>
//           <Box sx={{ px: 3, py: 3 }}>
//             <Typography sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}>
//               Are you sure you want to remove this item from your wishlist?
//             </Typography>
//           </Box>
//           <Box
//             sx={{
//               px: 3,
//               py: 2,
//               display: "flex",
//               justifyContent: "flex-end",
//               gap: 2,
//             }}
//           >
//             <Button
//               onClick={() => setOpenDeleteDialog(false)}
//               sx={{
//                 border: "1px solid rgb(54 54 54)",
//                 color: "#282828",
//                 padding: isMobile ? "6px 12px" : "0px 18px",
//                 fontSize: isMobile ? "0.85rem" : "1rem",
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={() => {
//                 handleRemoveItem(selectedModelId);
//                 setOpenDeleteDialog(false);
//               }}
//               variant="contained"
//               sx={{
//                 backgroundColor: "#d32f2f",
//                 color: "#fff",
//                 "&:hover": { backgroundColor: "#b71c1c" },
//                 padding: isMobile ? "6px 12px" : "0px 18px",
//                 fontSize: isMobile ? "0.85rem" : "1rem",
//               }}
//             >
//               Confirm
//             </Button>
//           </Box>
//         </Box>
//       </Modal>

//       <Modal
//         open={openMoveToCartDialog}
//         onClose={() => setOpenMoveToCartDialog(false)}
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: isMobile ? "85%" : 400,
//             maxWidth: 400,
//             bgcolor: "background.paper",
//             borderRadius: "12px",
//             boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//             overflow: "hidden",
//           }}
//         >
//           <Box sx={{ px: 3, py: 2 }}>
//             <Typography
//               variant="h6"
//               component="h2"
//               sx={{
//                 fontWeight: 600,
//                 fontSize: isMobile ? "1rem" : "1.25rem",
//               }}
//             >
//               Move to Cart
//             </Typography>
//           </Box>
//           <Box sx={{ px: 3, py: 3 }}>
//             <Typography sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}>
//               Are you sure you want to move this item to your cart?
//             </Typography>
//           </Box>
//           <Box
//             sx={{
//               px: 3,
//               py: 2,
//               display: "flex",
//               justifyContent: "flex-end",
//               gap: 2,
//             }}
//           >
//             <Button
//               onClick={() => setOpenMoveToCartDialog(false)}
//               sx={{
//                 border: "1px solid rgb(54 54 54)",
//                 color: "#282828",
//                 padding: isMobile ? "6px 12px" : "0px 18px",
//                 fontSize: isMobile ? "0.85rem" : "1rem",
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={() => {
//                 handleMoveToCart(selectedMoveModelId);
//                 setOpenMoveToCartDialog(false);
//               }}
//               variant="contained"
//               sx={{
//                 backgroundColor: "#d32f2f",
//                 color: "#fff",
//                 "&:hover": { backgroundColor: "#b71c1c" },
//                 padding: isMobile ? "6px 12px" : "0px 18px",
//                 fontSize: isMobile ? "0.85rem" : "1rem",
//               }}
//             >
//               Confirm
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default Wishlist;





// React & Core Hooks
import React, { useState, useEffect } from "react";

// Redux
import { useSelector, useDispatch } from "react-redux";

// React Router
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";

// MUI Core
import {
  Box,
  Container,
  Grid,
  Typography,
  Paper,
  Rating,
  IconButton,
  Button,
  Chip,
  ToggleButtonGroup,
  ToggleButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  CardMedia,
  Fade,
  Pagination,
  Select,
  MenuItem,
  CircularProgress,
  Tooltip,
  TextField,
  Snackbar,
  Alert,
  Tabs,
  Tab,
  Modal,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Radio,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
  useMediaQuery,
  useTheme,
  Breadcrumbs,
  Link as MuiLink
} from "@mui/material";

// MUI Icons
import {
  Close as CloseIcon,
  Straighten as StraightenIcon,
  Favorite,
  FavoriteBorder,
  LocalGasStation,
  DirectionsCar,
  GridView,
  List as ListIcon,
  AddShoppingCart,
  ChatBubbleOutline,
  Add,
  Remove,
  Share,
  ArrowBackIos,
  ArrowForwardIos,
  Close,
  Calculate as CalculateIcon,
  LocalShipping as LocalShippingIcon,
  DirectionsCar as DirectionsCarIcon,
  AttachMoney as AttachMoneyIcon,
  InfoOutlined as InfoOutlinedIcon,
  Receipt as ReceiptIcon,
  Delete,
} from "@mui/icons-material";

// MUI Styling
import { styled } from "@mui/material/styles";

// Custom Components
import Notes from "./header";
import BasicSelectFilter from "./filter";
import FooterManual from "./footerManual";
import InquiryModal from "./inquiryModal";

// Redux Actions
import {
  fetchCarsByBrand,
  fetchCarsByBodyType,
  fetchCarUsage,
  fetchCarsByPrice,
  fetchCarsByMileage,
  fetchCarsByEngine,
  fetchCarsByOtherSpecs,
  fetchCarsByColor,
  fetchAllCarModels,
  addToWishlist,
  fetchCart,
  fetchWishlist,
} from "./store";

// Third-party Libraries
import { useSnackbar } from "notistack";
import axios from "axios";


// ============================================================================
// STYLED COMPONENTS
// ============================================================================
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  overflow: "hidden",
  marginBottom: "16px",
  overflowX: "auto",
  [theme.breakpoints.down("sm")]: {
    borderRadius: "8px",
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
    width: `calc(100% + ${theme.spacing(2)})`,
    "& .MuiTable-root": { minWidth: "650px" },
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  cursor: "pointer",
  transition: "background-color 0.2s ease-in-out",
  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
  [theme.breakpoints.down("sm")]: {
    "& > .MuiTableCell-root": { padding: theme.spacing(1) },
  },
}));

const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#f5f5f5",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 10,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
    fontSize: "0.75rem",
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  cursor: "pointer",
  borderRadius: "10px",
  overflow: "hidden",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
    transform: "translateY(-2px)",
  },
  [theme.breakpoints.down("sm")]: {
    "& .MuiCardMedia-root": { height: "120px" },
    "& .MuiCardContent-root": { padding: "20px 8px" },
    "& .MuiButton-root": {
      fontSize: "0.7rem",
      padding: "4px 8px",
      minWidth: "unset",
    },
    "& .MuiTypography-h6": { fontSize: "0.9rem" },
    "& .MuiTypography-body2": { fontSize: "0.75rem" },
    "& .MuiChip-root": {
      height: "20px",
      "& .MuiChip-label": { fontSize: "0.65rem" },
    },
  },
}));

const SpinningLogo = styled("img")(({ theme }) => ({
  width: "150px",
  height: "150px",
}));

// ============================================================================
// WISHLIST GRID CARD COMPONENT
// ============================================================================

const WishlistGridCard = ({ item, onRemove, onMoveToCart, onInquiry, imageUrl, car, onCarClick }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isHovered, setIsHovered] = useState(false);
  const [openInquiryModal, setOpenInquiryModal] = useState(false);
  const [inquiryProduct, setInquiryProduct] = useState(null);
  const [modalImage, setModalImage] = useState(null);

  const fetchProductData = async (carModelId) => {
    try {
      const response = await axios.get(
        `https://car.amar.co.jp/api/dashboard/product/get/Model/details/${carModelId}`
      );
      return response.data?.data || null;
    } catch (err) {
      console.error('Error fetching product data:', err);
      return null;
    }
  };

  const handleInquiryClick = async (e, carModelId) => {
    e.stopPropagation();
    const productData = await fetchProductData(carModelId);
    if (productData) {
      setInquiryProduct(productData);
      setModalImage(`https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${carModelId}`);
      setOpenInquiryModal(true);
    } else {
      enqueueSnackbar('Failed to load car details for inquiry.', { variant: 'error' });
    }
  };

  const handleInquiryClose = () => {
    setOpenInquiryModal(false);
    setInquiryProduct(null);
    setModalImage(null);
  };

  return (
    <StyledCard
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        "&:hover": {
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          transform: "translateY(-4px)",
        },
        transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
        }}
        onClick={() => onCarClick(item.modelId)}
      >
        <CardMedia
          component="img"
          height="100%"
          image={`https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${item.modelId}`}
          alt={`${item.brand} ${item.modelName}`}
          sx={{
            transition: "transform 0.5s ease",
            transform: isHovered ? "scale(1.05)" : "scale(1)",
            objectFit: "cover",
            minHeight: "200px",
            backgroundColor: "#f5f5f5",
            filter: item.sold ? "grayscale(50%) brightness(0.7)" : "none",
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "carousel/carslider.png";
          }}
        />

        {/* SOLD Overlay */}
        {item.sold && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              color: "white",
              padding: isMobile ? "8px 24px" : "12px 32px",
              borderRadius: "8px",
              fontSize: isMobile ? "1.2rem" : "2rem",
              fontWeight: "bold",
              zIndex: 2,
              border: "3px solid #ff0000",
              boxShadow: "0 4px 12px rgba(255, 0, 0, 0.5)",
              letterSpacing: "2px",
            }}
          >
            SOLD
          </Box>
        )}

        <IconButton
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            backgroundColor: "rgba(255,255,255,0.9)",
            padding: isMobile ? "4px" : "8px",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,1)",
              transform: "scale(1.1)",
            },
            transition: "all 0.2s ease",
            zIndex: 3,
          }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove(item.modelId);
          }}
        >
          <Delete
            sx={{
              fontSize: isMobile ? "1rem" : "1.25rem",
              color: theme.palette.error.main,
            }}
          />
        </IconButton>
      </Box>

      <Box
        sx={{
          marginTop: "-15px",
          marginLeft: "15px",
          bottom: 8,
          left: 8,
          display: "flex",
          gap: 0.5,
          flexWrap: "wrap",
          zIndex: "1111"
        }}
      >
        {item.ourPick && (
          <Chip
            label="Our Pick"
            size="small"
            sx={{
              fontSize: isMobile ? "0.55rem" : "0.65rem",
              height: isMobile ? "16px" : "26px",
              color: "#dd006e",
              backgroundColor: "#ffbddf",
              fontWeight: "bold",
              border: "1px solid #FF69B4",
              "&:hover": { backgroundColor: "white" },
            }}
          />
        )}
        {item.carGrade && (
          <Chip
            label={`Grade ${item.carGrade || "A"}`}
            size="small"
            sx={{
              fontSize: isMobile ? "0.55rem" : "0.65rem",
              height: isMobile ? "16px" : "26px",
              color: "#009966",
              backgroundColor: "#9fffe7",
              fontWeight: "bold",
              border: "1px solid #00FFAA",
              "&:hover": { backgroundColor: "white" },
            }}
          />
        )}
        {item.specialDeal && (
          <Chip
            label="Special Offer"
            size="small"
            sx={{
              fontSize: isMobile ? "0.55rem" : "0.65rem",
              height: isMobile ? "16px" : "26px",
              backgroundColor: "#d09fff",
              color: "#6c2aab",
              fontWeight: "bold",
              border: "1px solid #6c2aab",
              "&:hover": { backgroundColor: "white" },
            }}
          />
        )}
      </Box>

      <CardContent
        sx={{
          flexGrow: 1,
          p: isMobile ? 1.5 : 2,
          display: "flex",
          flexDirection: "column",
        }}
        onClick={() => onCarClick(item.modelId)}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontSize: isMobile ? "1rem" : "1.125rem",
              fontWeight: 700,
              mb: 0.5,
              color: theme.palette.text.primary,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.brand} {item.modelName} {item.registrationDate?.split("-")[0]}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 1,
            "& > div": {
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            },
          }}
        >
          <Box>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "1rem" }}>Ref #:</Typography>
            <Typography variant="body2" sx={{ fontWeight: 500, fontSize: isMobile ? "0.75rem" : "0.8125rem" }}>{item.refNumber || "N/A"}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "1rem" }}>Year:</Typography>
            <Typography variant="body2" sx={{ fontWeight: 500, fontSize: isMobile ? "0.75rem" : "0.8125rem" }}>{item.registrationDate?.split("-")[0] || "N/A"}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "1rem" }}>Engine:</Typography>
            <Typography variant="body2" sx={{ fontWeight: 500, fontSize: isMobile ? "0.75rem" : "0.8125rem" }}>{item.carEngineCC || "N/A"}</Typography>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "1rem" }}>Fuel:</Typography>
            <Typography variant="body2" sx={{ fontSize: isMobile ? "0.65rem" : "0.75rem", color: theme.palette.text.primary }}>{item.fuel || "N/A"}</Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: "8px" }}>
          <Typography variant="caption" sx={{ fontWeight: 500, color: theme.palette.text.secondary, fontSize: isMobile ? "0.65rem" : "20px" }}>Price:</Typography>
          <Typography variant="h6" sx={{ fontSize: isMobile ? "1rem" : "20px", fontWeight: 700, color: theme.palette.error.main }}>{item.price ? `$${item.price.toLocaleString()}` : "Price on request"}</Typography>
        </Box>
      </CardContent>

      <Box sx={{ p: isMobile ? 1 : 1.5, pt: 0, display: "flex", justifyContent: "space-between", gap: 1 }}>
        <Button
          variant="contained"
          size="medium"
          disabled={item.sold}
          sx={{
            bgcolor: item.sold ? "grey.400" : "transparent",
            color: item.sold ? "grey.600" : "red",
            border: item.sold ? "1px solid grey" : "1px solid red",
            borderRadius: "50px",
            fontSize: "0.75rem",
            fontWeight: "600",
            padding: "18px 18px",
            width: "48%",
            height: "38px",
            transition: "all 0.3s ease",
            overflow: "hidden",
            position: "relative",
            zIndex: 1,
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: item.sold ? "grey" : "red",
              transform: "translateX(-100%)",
              transition: "transform 0.3s ease",
              zIndex: -1,
            },
            "&:hover": {
              color: item.sold ? "grey.600" : "white",
              boxShadow: item.sold ? "none" : "0 3px 6px rgba(255,0,0,0.3)",
              "&::before": { transform: item.sold ? "translateX(-100%)" : "translateX(0)" },
            },
          }}
          onClick={(e) => handleInquiryClick(e, item.modelId)}
        >
          {item.sold ? "SOLD OUT" : "INQUIRY"}
        </Button>
      </Box>

      <InquiryModal open={openInquiryModal} onClose={handleInquiryClose} product={inquiryProduct} imageUrl1={modalImage} />
    </StyledCard>
  );
};

// ============================================================================
// WISHLIST TABLE COMPONENT
// ============================================================================

const WishlistTable = ({ items, onRemove, onMoveToCart, onInquiry, car, imageUrl, onCarClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const visibleColumns = isMobile ? 10 : isTablet ? 10 : 11;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [openInquiryModal, setOpenInquiryModal] = useState(false);
  const [inquiryProduct, setInquiryProduct] = useState(null);
  const [modalImage, setModalImage] = useState(null);

  const fetchProductData = async (carModelId) => {
    try {
      const response = await axios.get(
        `https://car.amar.co.jp/api/dashboard/product/get/Model/details/${carModelId}`
      );
      return response.data?.data || null;
    } catch (err) {
      console.error('Error fetching product data:', err);
      return null;
    }
  };

  const handleInquiryClick = async (e, carModelId) => {
    e.stopPropagation();
    const productData = await fetchProductData(carModelId);
    if (productData) {
      setInquiryProduct(productData);
      setModalImage(`https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${carModelId}`);
      setOpenInquiryModal(true);
    } else {
      enqueueSnackbar('Failed to load car details for inquiry.', { variant: 'error' });
    }
  };

  const handleInquiryClose = () => {
    setOpenInquiryModal(false);
    setInquiryProduct(null);
    setModalImage(null);
  };

  return (
    <>
      <StyledTableContainer component={Paper}>
        <Table stickyHeader sx={{ minWidth: isMobile ? "650px" : "800px" }}>
          <TableHead>
            <TableRow>
              <StyledTableHeaderCell align="center">Drive This Beauty</StyledTableHeaderCell>
              {visibleColumns > 1 && <StyledTableHeaderCell align="center">Referance Number</StyledTableHeaderCell>}
              {visibleColumns > 2 && <StyledTableHeaderCell align="center">Chassis Number</StyledTableHeaderCell>}
              {visibleColumns > 3 && <StyledTableHeaderCell align="center">Registration Year</StyledTableHeaderCell>}
              {visibleColumns > 4 && <StyledTableHeaderCell align="center">Engine CC / Motor kW</StyledTableHeaderCell>}
              {visibleColumns > 5 && <StyledTableHeaderCell align="center">Fuel Type</StyledTableHeaderCell>}
              {visibleColumns > 7 && <StyledTableHeaderCell align="center">Body Color</StyledTableHeaderCell>}
              {visibleColumns > 8 && <StyledTableHeaderCell align="center">Car Doors</StyledTableHeaderCell>}
              {visibleColumns > 9 && <StyledTableHeaderCell align="center">Price</StyledTableHeaderCell>}
              <StyledTableHeaderCell align="center">Actions</StyledTableHeaderCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map((item) => (
              <StyledTableRow key={item.modelId} onClick={() => onCarClick(item.modelId)}>
                <TableCell sx={{ px: { xs: 1, sm: 2 }, }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: isMobile ? 1 : 2 }}>
                    <Box sx={{ position: "relative", width: isMobile ? 60 : 80, height: isMobile ? 45 : 60, flexShrink: 0 }}>
                      <Box
                        component="img"
                        src={`https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${item.modelId}`}
                        alt={`${item.brand} ${item.modelName}`}
                        sx={{ 
                          width: "100%", 
                          height: "100%", 
                          objectFit: "cover", 
                          borderRadius: 1, 
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)", 
                          backgroundColor: "#f5f5f5",
                          filter: item.sold ? "grayscale(50%) brightness(0.7)" : "none",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "carousel/carslider.png";
                        }}
                      />
                      
                      {/* SOLD Overlay for Table */}
                      {item.sold && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "rgba(0, 0, 0, 0.85)",
                            color: "white",
                            padding: isMobile ? "3px 8px" : "4px 12px",
                            borderRadius: "4px",
                            fontSize: isMobile ? "0.6rem" : "0.75rem",
                            fontWeight: "bold",
                            zIndex: 2,
                            border: "2px solid #ff0000",
                            letterSpacing: "1px",
                          }}
                        >
                          SOLD
                        </Box>
                      )}
                      
                      <IconButton
                        size="small"
                        color="error"
                        onClick={(e) => {
                          e.stopPropagation();
                          onRemove(item.modelId);
                        }}
                        sx={{ 
                          position: "absolute", 
                          top: 2, 
                          right: 2, 
                          padding: isMobile ? "2px" : "3px", 
                          backgroundColor: "rgba(255,255,255,0.8)",
                          zIndex: 3,
                        }}
                      >
                        <Delete sx={{ fontSize: isMobile ? 10 : 14 }} />
                      </IconButton>
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.875rem", wordWrap: "break-word", whiteSpace: "normal", lineHeight: 1.3 }}>
                        {item.brand} {item.modelName} {item.registrationDate?.split("-")[0]}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>

                {visibleColumns > 1 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem", fontFamily: "monospace" }}>{item.refNumber || "N/A"}</Typography></TableCell>}
                {visibleColumns > 2 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem", fontFamily: "monospace" }}>{item.carChassisNumber || "N/A"}</Typography></TableCell>}
                {visibleColumns > 3 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem" }}>{item.registrationDate ? item.registrationDate.split('-')[0] : "N/A"}</Typography></TableCell>}
                {visibleColumns > 4 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem" }}>{item.carEngineCC ? `${item.carEngineCC}` : "N/A"}</Typography></TableCell>}
                {visibleColumns > 5 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem" }}>{item.fuel || "N/A"}</Typography></TableCell>}
                {visibleColumns > 7 && (
                  <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Box sx={{ width: isMobile ? 12 : 16, height: isMobile ? 12 : 16, borderRadius: "50%", backgroundColor: item.carColor?.toLowerCase() || "#ccc", border: "1px solid #ddd", mr: 0.5 }} />
                      <Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem" }}>{item.carColor || "N/A"}</Typography>
                    </Box>
                  </TableCell>
                )}
                {visibleColumns > 8 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontSize: isMobile ? "0.7rem" : "0.875rem", fontFamily: "monospace" }}>{item.doors || "N/A"}</Typography></TableCell>}
                {visibleColumns > 9 && <TableCell align="center" sx={{ padding: isMobile ? "4px" : "8px" }}><Typography sx={{ fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.95rem", color: "error.main" }}>{item.price ? `$${item.price.toLocaleString()}` : "On Request"}</Typography></TableCell>}

                <TableCell align="center">
                  <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: 0.8, position: "relative", padding: "6px 0" }}>
                    <Button 
                      variant="contained" 
                      size="small" 
                      disabled={item.sold}
                      sx={{ 
                        bgcolor: item.sold ? "grey.400" : "transparent", 
                        color: item.sold ? "grey.600" : "red", 
                        border: item.sold ? "1px solid grey" : "1px solid red", 
                        borderRadius: "16px", 
                        fontSize: "0.75rem", 
                        padding: "3px 12px", 
                        minWidth: "80px", 
                        height: "28px", 
                        transition: "all 0.3s ease", 
                        position: "relative", 
                        zIndex: 1, 
                        "&:hover": { 
                          color: item.sold ? "grey.600" : "white", 
                          boxShadow: item.sold ? "none" : "0 3px 6px rgba(255,0,0,0.3)" 
                        } 
                      }} 
                      onClick={(e) => handleInquiryClick(e, item.modelId)}
                    >
                      {item.sold ? "SOLD OUT" : "INQUIRY"}
                    </Button>
                  </Box>
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
      <InquiryModal open={openInquiryModal} onClose={handleInquiryClose} product={inquiryProduct} imageUrl1={modalImage} />
    </>
  );
};

// ============================================================================
// MAIN WISHLIST COMPONENT
// ============================================================================

const Wishlist = () => {
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState("grid");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const [openMoveToCartDialog, setOpenMoveToCartDialog] = useState(false);
  const [selectedMoveModelId, setSelectedMoveModelId] = useState(null);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const wishlistState = useSelector(state => state.wishlist);
  const wishlistItems = wishlistState?.items || [];

  const handleClick = () => {
    navigate("/myAccount");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          navigate("/login");
          return;
        }

        await dispatch(fetchWishlist());
        setLoading(false);
      } catch (error) {
        console.error("Error fetching wishlist data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, navigate]);

  useEffect(() => {
    setTotalPages(Math.ceil(wishlistItems.length / itemsPerPage));
    setCurrentPage(1);
  }, [wishlistItems.length, itemsPerPage]);

  useEffect(() => {
    if (isMobile) {
      setViewMode("grid");
    } else {
      setViewMode("list");
    }
  }, [isMobile]);

  const handleRemoveItem = async (modelId) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const response = await fetch(
        `https://car.amar.co.jp/api/master/car-cart-and-whishlist/delete/item?Enter%20ModelId=${modelId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.code === 200) {
        dispatch(fetchWishlist());
        enqueueSnackbar("Item removed from wishlist", { variant: 'success' });
      }
    } catch (error) {
      console.error("Error removing item:", error);
      enqueueSnackbar("Error removing item", { variant: 'error' });
    }
  };

  const handleCarClick = (modelId) => {
    if (modelId) {
      navigate(`/product/${modelId}`);
    } else {
      console.error('No modelId provided for navigation');
    }
  };

  const handleMoveToCart = async (modelId) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const response = await fetch(
        `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=MOVE_TO_CART`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.code === 200) {
        dispatch(fetchWishlist());
        dispatch(fetchCart());
        enqueueSnackbar("Item moved to cart", { variant: 'success' });
      } else {
        console.error("Failed to move item to cart:", data.message);
        enqueueSnackbar("Failed to move item to cart", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error moving item to cart:", error);
      enqueueSnackbar("Error moving item to cart", { variant: 'error' });
    }
  };

  const handleViewMode = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
    setTotalPages(Math.ceil(wishlistItems.length / e.target.value));
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = wishlistItems.slice(indexOfFirstItem, indexOfLastItem);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <SpinningLogo src="/image/footer-logo-small.svg" alt="Loading" />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ mb: 0 }}>
        <Box sx={{ marginBottom: "0%" }}>
          <Notes />
        </Box>
      </Box>

      <Box
        className="image-container-Wishlist"
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "30vh", sm: "40vh", md: "50vh" },
          backgroundColor: "black",
        }}
      >
        {/* Background Image */}
        <Box
          component="img"
          src="/images/wishlist.png"
          alt="Wishlist Background"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.3,
          }}
        />

        {/* Breadcrumb */}
        <Box
          sx={{
            position: "absolute",
            top: { xs: "5%", sm: "5%", md: "5%" },
            left: { xs: "3%", sm: "5%", md: "5%" },
            color: "white",
            fontSize: { xs: "11px", sm: "13px", md: "15px" },
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            padding: { xs: "4px 8px", sm: "5px 10px", md: "5px 10px" },
            borderRadius: "5px",
          }}
        >
          <Typography
            component="span"
            sx={{
              opacity: 0.5,
              marginRight: { xs: "2px", sm: "5px" },
            }}
          >
            <Link
              to="http://3.110.209.177"
              style={{
                fontSize: "inherit",
                color: "white",
                textDecoration: "none",
              }}
            >
              Home/
            </Link>
          </Typography>

          <Link
            to="https://car.amar.co.jp/MyAccount"
            style={{
              fontSize: "inherit",
              color: "white",
              textDecoration: "none",
            }}
          >
            My Account
          </Link>

          / Wishlist
        </Box>

        {/* Center Content */}
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: { xs: "1.5rem", sm: "2rem", md: "30px" },
            fontFamily: "Roboto",
            fontWeight: 700,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: "10px", sm: "15px", md: "20px" },
            textAlign: "center",
            width: "90%",
          }}
        >
          Wishlist

          <Box
            component="button"
            onClick={handleClick}
            sx={{
              backgroundColor: "#EB2329",
              color: "white",
              border: "none",
              px: { xs: 2, sm: 2.5, md: 3 },
              py: { xs: 1, sm: 1.2, md: 1.4 },
              fontSize: { xs: "14px", sm: "15px", md: "16px" },
              borderRadius: "8px",
              cursor: "pointer",
              textTransform: "uppercase",
              transition: "background-color 0.3s ease",
              "&:hover": {
                backgroundColor: "#c41f23",
              },
            }}
          >
            My Account
          </Box>
        </Box>
      </Box>


      <Container
        maxWidth="xl"
        sx={{
          width: "90%",
          backgroundColor: "#FFFFFF",
          border: "2px solid #EBEBEB",
          borderRadius: "10px",
          marginTop: "-75px",
          marginBottom: "100px",
          position: "relative",
          zIndex: 1,
          minHeight: "400px",
          p: { xs: 2, md: 4 },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: isMobile ? 2 : 3,
            mb: 4,
            borderRadius: "10px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "space-between",
              alignItems: isMobile ? "flex-start" : "center",
              gap: isMobile ? 2 : 0,
            }}
          >
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  fontSize: isMobile ? "1.1rem" : "1.5rem",
                  color: "error.main",
                }}
              >
                My Wishlist
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ fontSize: isMobile ? "0.85rem" : "1rem" }}
              >
                {wishlistItems.length}{" "}
                {wishlistItems.length === 1 ? "result" : "results"} found
              </Typography>
            </Box>
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={handleViewMode}
              size={isMobile ? "small" : "medium"}
              sx={{
                "& .MuiToggleButton-root": {
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  color: "black",
                  "&.Mui-selected": {
                    backgroundColor: "red",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#cc0000",
                    },
                  },
                },
              }}
            >
              <ToggleButton value="list" title="List View">
                <ListIcon fontSize={isMobile ? "small" : "medium"} />
              </ToggleButton>
              <ToggleButton value="grid" title="Grid View">
                <GridView fontSize={isMobile ? "small" : "medium"} />
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Paper>

        {wishlistItems.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "300px",
              textAlign: "center",
            }}
          >
            <Favorite sx={{ fontSize: isMobile ? 40 : 60, color: "gray", mb: 2 }} />
            <Typography
              variant="h6"
              sx={{ mb: 1, fontSize: isMobile ? "1rem" : "1.25rem" }}
            >
              Your wishlist is empty
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 3, fontSize: isMobile ? "0.85rem" : "1rem" }}
            >
              You haven't added any items to your wishlist yet.
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#d32f2f",
                "&:hover": { backgroundColor: "#b71c1c" },
                fontSize: isMobile ? "0.85rem" : "1rem",
              }}
              onClick={() => navigate("/")}
            >
              Browse Cars
            </Button>
          </Box>
        ) : (
          <>
            {viewMode === "list" ? (
              <WishlistTable
                items={currentItems}
                onCarClick={handleCarClick}
                car={currentItems}
                onRemove={(id) => {
                  setSelectedModelId(id);
                  setOpenDeleteDialog(true);
                }}
                onMoveToCart={(id) => {
                  setSelectedMoveModelId(id);
                  setOpenMoveToCartDialog(true);
                }}
              />
            ) : (
              <Grid container spacing={isMobile ? 1 : 3}>
                {currentItems.map((item) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={item.modelId}
                  >
                    <WishlistGridCard
                      item={item}
                      onCarClick={handleCarClick}
                      car={item}
                      onRemove={() => {
                        setSelectedModelId(item.modelId);
                        setOpenDeleteDialog(true);
                      }}
                      onMoveToCart={() => {
                        setSelectedMoveModelId(item.modelId);
                        setOpenMoveToCartDialog(true);
                      }}
                      onInquiry={() => console.log("Inquiry clicked")}
                    />
                  </Grid>
                ))}
              </Grid>
            )}

            {wishlistItems.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 4,
                  flexDirection: isMobile ? "column" : "row",
                  gap: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "black",
                      fontWeight: 500,
                      letterSpacing: "0.5px",
                      fontSize: isMobile ? "0.85rem" : "1rem",
                    }}
                  >
                    Results per page:
                  </Typography>
                </Box>

                <Pagination
                  count={totalPages || 0}
                  page={currentPage}
                  onChange={handlePageChange}
                  variant="outlined"
                  shape="rounded"
                  size={isMobile ? "small" : "medium"}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    "& .MuiPaginationItem-root": {
                      fontWeight: 500,
                      borderColor: "black",
                      color: "black",
                      "&:hover": {
                        backgroundColor: "rgba(255, 0, 0, 0.1)",
                        borderColor: "red",
                      },
                    },
                    "& .Mui-selected": {
                      backgroundColor: "red !important",
                      color: "white",
                      borderColor: "red",
                      "&:hover": {
                        backgroundColor: "#b30000 !important",
                        borderColor: "#800000",
                      },
                    },
                  }}
                />

                <Select
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  variant="outlined"
                  displayEmpty
                  size="small"
                  sx={{
                    width: isMobile ? 70 : 80,
                    color: "black",
                    fontWeight: 500,
                    backgroundColor: "#fff",
                    borderColor: "black",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "black",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "red",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "red",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "red",
                    },
                  }}
                >
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </Box>
            )}
          </>
        )}
      </Container>

      <FooterManual />

      <Modal open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "85%" : 400,
            maxWidth: 400,
            bgcolor: "background.paper",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            overflow: "hidden",
          }}
        >
          <Box sx={{ px: 3, py: 2 }}>
            <Typography
              variant="h6"
              component="h2"
              sx={{
                fontWeight: 600,
                fontSize: isMobile ? "1rem" : "1.25rem",
              }}
            >
              Remove from Wishlist
            </Typography>
          </Box>
          <Box sx={{ px: 3, py: 3 }}>
            <Typography sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}>
              Are you sure you want to remove this item from your wishlist?
            </Typography>
          </Box>
          <Box
            sx={{
              px: 3,
              py: 2,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              onClick={() => setOpenDeleteDialog(false)}
              sx={{
                border: "1px solid rgb(54 54 54)",
                color: "#282828",
                padding: isMobile ? "6px 12px" : "0px 18px",
                fontSize: isMobile ? "0.85rem" : "1rem",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleRemoveItem(selectedModelId);
                setOpenDeleteDialog(false);
              }}
              variant="contained"
              sx={{
                backgroundColor: "#d32f2f",
                color: "#fff",
                "&:hover": { backgroundColor: "#b71c1c" },
                padding: isMobile ? "6px 12px" : "0px 18px",
                fontSize: isMobile ? "0.85rem" : "1rem",
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openMoveToCartDialog}
        onClose={() => setOpenMoveToCartDialog(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "85%" : 400,
            maxWidth: 400,
            bgcolor: "background.paper",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            overflow: "hidden",
          }}
        >
          <Box sx={{ px: 3, py: 2 }}>
            <Typography
              variant="h6"
              component="h2"
              sx={{
                fontWeight: 600,
                fontSize: isMobile ? "1rem" : "1.25rem",
              }}
            >
              Move to Cart
            </Typography>
          </Box>
          <Box sx={{ px: 3, py: 3 }}>
            <Typography sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}>
              Are you sure you want to move this item to your cart?
            </Typography>
          </Box>
          <Box
            sx={{
              px: 3,
              py: 2,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              onClick={() => setOpenMoveToCartDialog(false)}
              sx={{
                border: "1px solid rgb(54 54 54)",
                color: "#282828",
                padding: isMobile ? "6px 12px" : "0px 18px",
                fontSize: isMobile ? "0.85rem" : "1rem",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleMoveToCart(selectedMoveModelId);
                setOpenMoveToCartDialog(false);
              }}
              variant="contained"
              sx={{
                backgroundColor: "#d32f2f",
                color: "#fff",
                "&:hover": { backgroundColor: "#b71c1c" },
                padding: isMobile ? "6px 12px" : "0px 18px",
                fontSize: isMobile ? "0.85rem" : "1rem",
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Wishlist;